module.exports = __webpack_public_path__ + "img/Lycan.645ea0f1.png";